import SharedCheckout from "pages/checkout/Checkout";
import { StorefrontLayoutProvider } from "storefronts/StorefrontLayoutBridge";
import MxStorefrontLayout from "../components/MxStorefrontLayout";

export default function CheckoutPage() {
  return (
    <StorefrontLayoutProvider layout={MxStorefrontLayout}>
      <SharedCheckout />
    </StorefrontLayoutProvider>
  );
}
